import CartPage from './CartPage';
import CheckoutPage from './CheckoutPage';
import OrderDetailsPage from './OrderDetailsPage';
import UploadGoogleReview from './UploadGoogleReview';
import Tabs from './tabs';
import Rewards from './rewards';

export default {
  CartPage,
  CheckoutPage,
  OrderDetailsPage,
  UploadGoogleReview,
  Tabs,
  Rewards,
};
